"use client";
import { useCompositeSeparator } from "../composite/composite-separator.js";
import { useMenuContext } from "./menu-context.js";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
//#region src/menu/menu-separator.tsx
const TagName = "hr";
/**
* Returns props to create a `MenuSeparator` component.
* @see https://ariakit.com/components/menu
* @example
* ```jsx
* const store = useMenuStore();
* const props = useMenuSeparator({ store });
* <MenuButton store={store}>Edit</MenuButton>
* <Menu store={store}>
*   <MenuItem>Undo</MenuItem>
*   <MenuItem>Redo</MenuItem>
*   <Role {...props} />
*   <MenuItem>Cut</MenuItem>
* </Menu>
* ```
*/
const useMenuSeparator = createHook(function useMenuSeparator({ store, ...props }) {
	const context = useMenuContext();
	store = store || context;
	props = useCompositeSeparator({
		store,
		...props
	});
	return props;
});
/**
* Renders a divider between
* [`MenuItem`](https://ariakit.com/reference/menu-item),
* [`MenuItemCheckbox`](https://ariakit.com/reference/menu-item-checkbox), and
* [`MenuItemRadio`](https://ariakit.com/reference/menu-item-radio) elements.
* @see https://ariakit.com/components/menu
* @example
* ```jsx {6}
* <MenuProvider>
*   <MenuButton>Edit</MenuButton>
*   <Menu>
*     <MenuItem>Undo</MenuItem>
*     <MenuItem>Redo</MenuItem>
*     <MenuSeparator />
*     <MenuItem>Cut</MenuItem>
*   </Menu>
* </MenuProvider>
* ```
*/
const MenuSeparator = forwardRef(function MenuSeparator(props) {
	return createElement(TagName, useMenuSeparator(props));
});
//#endregion
export { MenuSeparator, useMenuSeparator };

//# sourceMappingURL=menu-separator.js.map